import React from 'react';
import {cn} from '@utils';

export interface BaseItem {
  key: string;
  label: string;
}

const activeCls = 'rounded-full bg-[#DF8157] text-white';
const baseTab = 'flex-1 h-full flex items-center justify-center';

export interface FissionTabsProps<T extends BaseItem> {
  items: T[];
  activeKey?: string;
  onChange?: (activeKey: string, item: T) => void;
  renderItem?: (item: T, isActive: boolean) => React.ReactNode;
}

export default function FissionTabs<T extends BaseItem>({
  items = [],
  activeKey,
  onChange,
  renderItem,
}: FissionTabsProps<T>) {
  const activeTabKey = activeKey || (items[0]?.key ?? '');

  const handleTabClick = (item: T) => {
    onChange?.(item.key, item);
  };

  return (
    <div className="bg-[#FFFBF8] relative p-1 flex font-medium text-base rounded-full w-[305px] h-[36px] text-center items-center text-[#DF8157]">
      {items.map(item => {
        const isActive = item.key === activeTabKey;
        return (
          <div
            key={item.key}
            className={cn(baseTab, isActive && activeCls)}
            onClick={() => handleTabClick(item)}>
            {renderItem ? renderItem(item, isActive) : item.label}
          </div>
        );
      })}
    </div>
  );
}
